import HttpWrapper from '@/utils/http/httpWrapper'
import ShipbobAppSettings from '../../appSettings/appSetting'
import { store } from '@/store'
import toastr from 'toastr'
import { SystemSettingsService } from '../systemSettings'

export const PUBLIC_SHIPMENT_API_BASE = ShipbobAppSettings.fulfillmentApi
export const PUBLIC_ORDERS_API_BASE = ShipbobAppSettings.publicOrdersApi
export const CLAIMS_FUNCTION = ShipbobAppSettings.claimsFunction
const ORDERS_API = ShipbobAppSettings.ordersapi + '/api/orders'
const ADDRESS_VALIDATOR = ShipbobAppSettings.addressValidator + '/api'
const ASSIGN_FULFILLMENT_CENTER = ShipbobAppSettings.photoPrint + '/ShipBobWebOrders/AssignFulfillmentCenter'
const PHOTOPRINT_BASE = ShipbobAppSettings.photoPrint
const PHOTOPRINT = PHOTOPRINT_BASE + '/api'
const CONTROL_PLANE_API = ShipbobAppSettings.controlPlaneApi
const LABELINGAPI_BASE = ShipbobAppSettings.labelingApi
const SHIPMENTTRACKINGAPI_BASE = ShipbobAppSettings.shipmentTrackingApiURL
const ORDERACTION_API = ShipbobAppSettings.orderActionApi
const V2_BASE = ShipbobAppSettings.shipbobV2Api
const PACKINGSLIP_BASE = ShipbobAppSettings.PackingSlipBaseUrl


class ShipmentServiceInternal {
  urls () {
    return {
      shipment: PUBLIC_SHIPMENT_API_BASE + '/{shipmentId}',
      metaData: `${ORDERS_API}/{orderId}/metaData`,
      storeOrderData: `${ORDERS_API}/{orderId}/storeOrderData`,
      saveGiftMessage: `${V2_BASE}/api/orders/updateGiftMessage`,
      associatedOrders: PUBLIC_ORDERS_API_BASE + '/{masterOrderId}/shipment',
      logs: PUBLIC_SHIPMENT_API_BASE + '/{shipmentId}/logs',
      updateShipment: `${PHOTOPRINT}/orderDetails/updateOrderItems`,
      validateAddress: `${ADDRESS_VALIDATOR}/AddressValidator/validate`,
      v2ValidateAddress: `${ADDRESS_VALIDATOR}/v2/address/validate`,
      shipmentTimeline: PUBLIC_SHIPMENT_API_BASE + '/{shipmentId}/timeline',
      saveAddress: `${PHOTOPRINT}/OrderDetails/UpdateOrderRecipientInfo`,
      saveFulfillmentCenter: `${ASSIGN_FULFILLMENT_CENTER}?fulfillmentCenterId={fulfillmentCenterId}&orderId={orderId}`,
      updateShipOption: `${CONTROL_PLANE_API}/api/v1/shipment:bulkUpdateShippingService`,
      updateInsurance: `${CONTROL_PLANE_API}/api/v1/shipment/{shipmentId}:updateInsuranceValue`,
      splitOrder: `${PHOTOPRINT_BASE}/Home/SVCAmendOrder`,
      orderLineItems: `${ORDERS_API}/{orderId}/orderLineItems`,
      addSignatureRequest: `${PHOTOPRINT_BASE}/Orders/SvcAddSignaturerRequiredInstruction`,
      uploadAttachment: `${PHOTOPRINT_BASE}/ShipBobOrderDetails/UploadAttachment`,
      updateEmailSubscriptions: `${PHOTOPRINT_BASE}/ShipBobWebOrder/SvcSubscribeTrackingUpdates`,
      viewLabel: `${LABELINGAPI_BASE}/api/Labeling/ViewLabel?OrderId={orderId}`,
      cancelShipment: PUBLIC_SHIPMENT_API_BASE + '/{shipmentId}/cancel',
      processActions: ORDERACTION_API + '/ProcessSynchronousActionsOauth', // This one is for calling new API
      viewPackingSlip: `${PACKINGSLIP_BASE}/api/PackingSlip/viewPackingSlip?OrderId={orderId}`,
      getTrackingUrlFromLabelingService: `${LABELINGAPI_BASE}/api/CarrierTracking?OrderId={orderId}`,
      getTrackingUrlFromShipmentTrackingService: `${SHIPMENTTRACKINGAPI_BASE}/api/v1/ordertracking/trackingUrl?orderId={orderId}`,
      submitClaimUrl: `${CLAIMS_FUNCTION}/api/FileShipmentClaim`,
      canFileClaimUrl: `${CLAIMS_FUNCTION}/api/CanFileClaim`,
      fileClaimSubmited: `${CLAIMS_FUNCTION}/api/ClaimSubmited`
    }
  }

  async submitClaim (data) {
    const request = {
      Url: this.urls().submitClaimUrl,
      Data: data
    }
    const disableErrorMessages = true
    return await HttpWrapper.Post(request, HttpWrapper.noop, HttpWrapper.noop, disableErrorMessages)
  }

  async canFileClaim (data) {
    const request = {
      Url: this.urls().canFileClaimUrl,
      Data: data
    }
    return await HttpWrapper.Post(request)
  }

  async fileClaimSubmited (data) {
    const request = {
      Url: this.urls().fileClaimSubmited,
      Data: data
    }
    return await HttpWrapper.Post(request)
  }

  async getShipment (shipmentId) {
    const request = {
      Url: this.urls().shipment.replace('{shipmentId}', shipmentId)
    }
    return await HttpWrapper.Get(request)
  }

  async getAssociatedOrders (masterOrderId) {
    const request = {
      Url: this.urls().associatedOrders.replace('{masterOrderId}', masterOrderId)
    }
    return await HttpWrapper.Get(request)
  }

  async getMetaData (orderId) {
    const request = {
      Url: this.urls().metaData.replace('{orderId}', orderId)
    }
    return await HttpWrapper.Get(request)
  }

  async getOrderLogs (shipmentId) {
    const request = {
      Url: this.urls().logs.replace('{shipmentId}', shipmentId)
    }
    return await HttpWrapper.Get(request)
  }

  async getShipmentTimeline (shipmentId) {
    const request = {
      Url: this.urls().shipmentTimeline.replace('{shipmentId}', shipmentId)
    }
    return await HttpWrapper.Get(request)
  }

  async addProductsToOrder (addProductsToOrder) {
    const request = {
      Url: this.urls().updateShipment,
      Data: addProductsToOrder
    }
    if (await HttpWrapper.Post(request, null, null, true)) {
      toastr.success('Successfully updated the order.')
      return true
    } else {
      toastr.error('Failed to update products in the order. Please try again or contact support.')
      return false
    }
  }

  async validateAddress (address) {
    const isAddressValidationV2Enabled = store.getters.enableAddressValidationV2
    const request = {
      Url: isAddressValidationV2Enabled ? this.urls().v2ValidateAddress : this.urls().validateAddress,
      Data: { ...address }
    }
    return await HttpWrapper.Post(request, null, null, true)
  }

  async saveAddress (address) {
    const request = {
      Url: this.urls().saveAddress,
      Data: { ...address }
    }
    return await HttpWrapper.Post(request)
  }

  async addSignatureRequest (shipmentId) {
    const request = {
      Url: this.urls().addSignatureRequest,
      Params: { orderId: shipmentId }
    }
    return await HttpWrapper.Get(request)
  }

  async splitOrder (Data) {
    const request = {
      Url: this.urls().splitOrder,
      Data
    }
    return await HttpWrapper.Post(request)
  }

  async saveFulfillmentCenter (data) {
    const request = {
      Url: this.urls().saveFulfillmentCenter.replace('{fulfillmentCenterId}', data.fcId).replace('{orderId}', data.orderId)
    }
    return await HttpWrapper.Post(request, null, null, true)
  }

  async updateShipOption (data) {
    const request = {
      Url: this.urls().updateShipOption,
      Data: {
        shipment_ids: [data.orderId],
        requested_shipping_service_id: data.shipOptionId,
        reason: 'Manual update in the shipment details dashboard by the user'
      }
    }

    return await HttpWrapper.Put(request, null, null, true)
  }

  async updateInsurance (data) {
    const request = {
      Url: this.urls().updateInsurance.replace('{shipmentId}', data.orderId),
      Data: { insurance_value: data.insurance }
    }
    return await HttpWrapper.Put(request, null, null, true)
  }

  async getOrderLineItems (orderId) {
    const request = {
      Url: this.urls().orderLineItems.replace('{orderId}', orderId)
    }
    return await HttpWrapper.Get(request)
  }

  async addAttachmentToOrder ({ orderId, file, type }) {
    const dataString = `{"orderId":${orderId},"fileName":"${file.name}","type":${type}}`
    const formData = new FormData()
    formData.append('file', file)
    formData.append('data', dataString)
    const request = {
      Url: this.urls().uploadAttachment,
      Data: formData,
      Headers: { 'Content-Type': 'multipart/form-data' }
    }
    return await HttpWrapper.Post(request)
  }

  async addGiftMessageToOrder (orderId, message) {
    const obj = {
      orderId: orderId,
      giftMessage: message
    }
    const request = {
      Url: this.urls().saveGiftMessage,
      Data: obj
    }
    return await HttpWrapper.Post(request)
  }

  async updateEmailSubscriptions (Data) {
    const request = {
      Url: this.urls().updateEmailSubscriptions,
      Data
    }
    return await HttpWrapper.Post(request, () => {
      toastr.success('Subscriptions successfully updated')
    })
  }

  async getStoreOrderData (orderId) {
    const request = {
      Url: this.urls().storeOrderData.replace('{orderId}', orderId)
    }
    return await HttpWrapper.Get(request)
  }

  async getShipmentLabel (orderId) {
    const request = {
      Url: this.urls().viewLabel.replace('{orderId}', orderId),
      ResponseType: 'blob'
    }
    return await HttpWrapper.Get(request)
  }

  async getRetailerPackingSlip (orderId) {
    const request = {
      Url: this.urls().viewPackingSlip.replace('{orderId}', orderId),
      ResponseType: 'blob'
    }
    return await HttpWrapper.Get(request)
  }

  extractDetailsErrorMessages (res) {
    const genericMessage = 'Error occurred!'
    const message = res.response && res.response.data && res.response.data.Message
    return message !== undefined ? message : genericMessage
  }

  extractDetailsSuccessMessages (res) {
    const genericMessage = 'Successful!'
    let message = res.data && res.data.Message
    let transactionId = res.data && res.data.TransactionId
    message = message !== undefined ? message : genericMessage
    transactionId = transactionId !== undefined ? transactionId : null

    var isSuccess = true

    if (res.data !== undefined && Array.isArray(res.data.results)) {
      for (let i = 0; i < res.data.results.length; i++) {
        isSuccess = isSuccess && res.data.results[i].isSuccess
        if (isSuccess === false) {
          message = 'Error! ' + res.data.results[i].message
          break
        } else {
          message += ' ' + res.data.results[i].message
        }
      }
    }
    return { message, transactionId, isSuccess }
  }

  async cancelShipment (shipmentId) {
    toastr.info('Processing...')

    const request = {
      Url: this.urls().cancelShipment.replace('{shipmentId}', shipmentId)
    }
    if (await HttpWrapper.Post(request, null, null, true)) {
      toastr.success('Order successfully cancelled')
      return true
    } else {
      toastr.error('Order could not be cancelled')
      return false
    }
  }

  async processOrderAction (Data) {
    toastr.info('Processing...')

    const request = {
      Url: this.urls().processActions,
      Data
    }
    return await HttpWrapper.Post(request, (res) => {
      const responseModel = this.extractDetailsSuccessMessages(res)
      if (responseModel.isSuccess === true) {
        toastr.success(responseModel.message)
      } else {
        toastr.error(responseModel.message)
      }
    },
    (res) => {
      const msg = this.extractDetailsErrorMessages(res)
      toastr.error(msg)
    }, true)
  }

  async getTrackingUrl (orderId) {
    const bypassLabelingForTracking = await SystemSettingsService.get('MerchantAppUseShipmentTrackingForURL')
    const trackingUrl = bypassLabelingForTracking.Enabled ? this.urls().getTrackingUrlFromShipmentTrackingService : this.urls().getTrackingUrlFromLabelingService
    const request = {
      Url: trackingUrl.replace('{orderId}', orderId)
    }
    return await HttpWrapper.Get(request)
  }
}

export const ShipmentService = new ShipmentServiceInternal()
